import React from 'react';
import { SortableContainer } from 'react-sortable-hoc';
import CheckedContainer from '../CheckedContainer';

interface Props {
  tableCols: any;
  columnConfig: any;
  onCheckBoxClick: (event: any) => void;
}

const CheckedList = SortableContainer((props: Props) => {
  const { tableCols, columnConfig, onCheckBoxClick } = props;

  return (
    <CheckedContainer
      tableCols={tableCols}
      columnConfig={columnConfig}
      onCheckBoxClick={onCheckBoxClick}
    />
  );
});

export default CheckedList;
